import * as n from "react";
import "react-dom";
import { createSlot as f } from "../../../../../@radix-ui_react-slot@1.2.4_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-slot/dist/index.js";
import { j as l } from "../../../../../../../_virtual/jsx-runtime.js";
var u = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], w = u.reduce((t, i) => {
  const o = f(`Primitive.${i}`), r = n.forwardRef((e, m) => {
    const { asChild: a, ...s } = e, p = a ? o : i;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(p, { ...s, ref: m });
  });
  return r.displayName = `Primitive.${i}`, { ...t, [i]: r };
}, {});
export {
  w as Primitive
};
